module.exports = __webpack_public_path__ + "img/compact.7029330c.png";